import { Component } from '@angular/core';
import {
    MatLegacyDialogModule as MatDialogModule,
    MatLegacyDialogRef as MatDialogRef,
} from '@angular/material/legacy-dialog';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { MatIconModule } from '@angular/material/icon';
import { OnboardingIntroContentComponent } from '../onboarding-intro-content/onboarding-intro-content.component';

export interface BankAccountKycDialogResult {
    startVerification: boolean;
}

@Component({
    selector: 'app-bank-account-kyc-dialog',
    standalone: true,
    imports: [
        MatDialogModule,
        MatButtonModule,
        MatIconModule,
        OnboardingIntroContentComponent,
    ],
    templateUrl: './bank-account-kyc-dialog.component.html',
    styleUrls: ['./bank-account-kyc-dialog.component.scss'],
})
export class BankAccountKycDialogComponent {
    constructor(
        private _dialogRef: MatDialogRef<BankAccountKycDialogComponent, BankAccountKycDialogResult>,
    ) {}

    startVerification(): void {
        this._dialogRef.close({ startVerification: true });
    }

    close(): void {
        this._dialogRef.close({ startVerification: false });
    }
}
